import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import NullStateDiv from '@components/NullStateDiv';

import type { ListAlertSettingsQuery } from 'generated/alert_setting.generated';

import AlertSettingItem from './AlertSettingItem/AlertSettingItem';

const messages = defineMessages({
  noAlertSettings: {
    id: 'alertSettingTable.noAlertSettings',
    defaultMessage: 'No Alert Settings',
  },
});

interface AlertSettingListProps {
  data: ListAlertSettingsQuery['listAlertSettings'];
}

export default function AlertSettingsList({ data }: AlertSettingListProps) {
  const { formatMessage } = useIntl();

  return (
    <>
      {data.length ? (
        data.map((d) => (
          <AlertSettingItem
            key={`alert-setting-${d.alert_setting_id}`}
            setting={d}
          />
        ))
      ) : (
        <NullStateDiv>{formatMessage(messages.noAlertSettings)}</NullStateDiv>
      )}
    </>
  );
}
